export class State {
    data = {
        "id": null,
        "name": null,
    };

    constructor(public data1: any) {
        this.data = data1;
    }

    //shortHeaders = [];
    prefix = "state";
    title = "State";
    dataFields = {
        id: {'title': 'ID', 'value': null, 'type': 'number', 'readonly': true},
        name: {'title': 'username', 'value': null, 'type': 'text'},
    }
}
